// helpers
import PersonalDataHelper from 'utilities/personalDataHelper';
import { i18n } from 'core/i18n';

const KEYS_CONTEXT = 'interventionTypes';

const INTERVENTION_TYPES_TEXTS = {
  '01': `${KEYS_CONTEXT}-TITULAR`,
  '07': `${KEYS_CONTEXT}-APODERADO`,
  '08': `${KEYS_CONTEXT}-AUTORIZADO`,
  '09': `${KEYS_CONTEXT}-REPRESENTANTE LEGAL`,
  '25': `${KEYS_CONTEXT}-REPRE. LEGAL PERSONA JURIDICA`
}

export const getRenovationCancelPrintedDocumentParams = (profileInfo, renovationInfo) => {
    const clientName = PersonalDataHelper.getFullName(profileInfo, false);
    const clientDocument = profileInfo.getIn(['documentoIdentificacion','codigodocumpersonacorp']);
    const clientNumber = profileInfo.getIn(['codigoPersona','f']);
    const renovation = renovationInfo.getIn(['renovations','0','originalImpositions','0']);
    const interveners = renovation.get('depositRenewalInterveners').toJS();
    const amount = renovation.get('renewalAmount');
    const requestDate = renovation.get('requestDate');
    const depositStartDate = renovation.get('originalImpositionExpirationDate');
    const currentIntervener = interveners.find(intervener => (intervener.intervenerClientNumber == clientNumber));
    const interventionType = i18n.formatText(INTERVENTION_TYPES_TEXTS[currentIntervener.intervenerInterventionType]);
    const productName = renovationInfo.getIn(['renovations','0','renewalDepositName']);
    return {
        precontractualType: "CANCEL_DEPOSIT_RENEWAL_OFFICE",
        metadata: {
          nameSurname: clientName,
          documentNumber: clientDocument,
          interventionType: interventionType,
          productType: productName,
          depositCancellationDate: requestDate,
          amount: amount,
          effectiveDate: depositStartDate
        }
      }
}